import { BOOKMARK_CLASS_ID } from './constants';
import type { FetchResponse, RestService } from '@sydle/ui-api';
import { buildRequestParams } from '@sydle/ui-api';

export type DefaultBookmarkMethodsInputArgs = {
  objectId: string;
  classId: string;
};

export type GetBookmarksInput = {
  searchParams: {
    searchText?: string;
    from: number;
  };
  timezoneId: string;
  timezoneOffset: number;
  getCardsOptions: {
    ignoreGroups?: string[];
    timezoneId: string;
  };
};

export type IsBookmarkedOutput = { _singleValue: boolean };

export class BookmarkAPI {
  private restService: RestService;

  constructor(restService: RestService) {
    this.restService = restService;
  }

  public async isBookmarked(
    isBookmarkedInput: DefaultBookmarkMethodsInputArgs,
  ): Promise<FetchResponse<IsBookmarkedOutput>> {
    return this.restService.get(
      buildRequestParams({
        _classId: BOOKMARK_CLASS_ID,
        methodIdentifier: 'isBookmarked',
        queryParams: {
          classId: isBookmarkedInput.classId,
          objectId: isBookmarkedInput.objectId,
        },
      }),
    );
  }

  public async bookmark(bookmarkInput: DefaultBookmarkMethodsInputArgs): Promise<FetchResponse<any>> {
    return this.restService.post(
      buildRequestParams({
        _classId: BOOKMARK_CLASS_ID,
        methodIdentifier: 'bookmark',
        body: bookmarkInput,
      }),
    );
  }

  public async unbookmark(unbookmarkInput: DefaultBookmarkMethodsInputArgs): Promise<FetchResponse<any>> {
    return this.restService.post(
      buildRequestParams({
        _classId: BOOKMARK_CLASS_ID,
        methodIdentifier: 'unbookmark',
        body: unbookmarkInput,
      }),
    );
  }

  public async getBookmarks(getBookmarksInput: GetBookmarksInput): Promise<FetchResponse<any>> {
    return this.restService.post(
      buildRequestParams({
        _classId: BOOKMARK_CLASS_ID,
        methodIdentifier: 'getBookmarks',
        body: getBookmarksInput,
      }),
    );
  }
}
